import { FormMetaModel } from "common/models/utility-models/meta-model";

export class AppFormmetaModel extends FormMetaModel {
    constructor() {
        super('App', '', '', 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();

        return {
            formInfo,


        }
    }


}